$(document).ready(function() {

  // Megamenu au survol
  $(".header__inline-menu details").hover(function (e) {
    $(this).attr("open", true);
    $(this).find(".open_first_submenu .level_2").addClass("selected");
  }, function (e) {
    $(this).find(".open_first_submenu .menus").show();
    $(this).attr("open", false);
  });

  $(".submenu_level_1 > div").hover(function (e) {
    $(this).find(".menus").show();
    $(this).find(".submenu_level_2").mouseleave(function (e) {
      $(this).find(".menus").hide();
    });
  }, function (e) {
    $(this).find(".level_2").removeClass("selected");
    $(this).find(".menus").hide();
  });

  // Menu mobile
  $(".menu-drawer__menu-item.level_1").on("click", function (e) {
    $(this).toggleClass("open");
    $(this).next("div").slideToggle();
  });

  $(".menu-drawer__menu-item.level_2").on("click", function (e) {
    $(this).next("div").addClass("open");
  });

  $(".menu-drawer__close-button").on("click", function (e) {
    $(".menu-drawer__submenu_3").removeClass("open");
  });

  // Reassurance
  $('.reassurance .page-width div').each(function() {
    var is_anchor = $(this).find('a');
    if (is_anchor.length > 0) {
      $(this).addClass('pointer');
    }
  });

  $('.reassurance .page-width div').click(function() {
    var is_anchor = $(this).find('a');
    if (is_anchor.length > 0) {
      window.location.redirect = is_anchor.attr('href');
    }
  });

  if ($(window).width() <= 749) {
    $('.reassurance .page-width').slick({
      arrows: false,
      dots: false,
      autoplay: true,
      slidesToShow: 2,
    });
  }


  // Footer accordéon
  if ($(window).width() <= 749) {
    $(".footer_navigation .page-width > * > p").click(function(e) {
      $(".footer_navigation .page-width > * > p").not($(this)).removeClass("open");
      $(this).toggleClass("open");
      var tabs = $(".footer_navigation .page-width > * > p");
      var content = $(".footer_navigation .page-width > * > div");
      if (content.length) {
         $(tabs).not($(this)).next(content).slideUp();
          $(this).next("div").slideToggle();
      }
    });
  }

  // Lien sur section banner entière
   $(".header__menu-item.level_1 span").click(function(e) {
      var redirect = $(this).data("target");
      window.location.href = redirect;
   });

  // Custom product form activation
  if ($("#custom_product_widget").length) {

    $("#custom_activated").removeAttr("checked");

    $("#custom_activated").on("change", function() {
      if($("#custom_activated").is(":checked")) {
        $("#custom_product_widget .custom_fields, #custom_product_widget .custom_text").fadeIn();
        $(".custom_product_field").removeAttr('disabled').attr('required','required');
        $(".custom_fields input.field__input").trigger("keyup");
        $(".custom_fields select.select__select").trigger("change");
      } else {
        $("#custom_product_widget .custom_fields, #custom_product_widget .custom_text").fadeOut();
        $(".custom_product_field").attr('disabled','disabled').removeAttr('required');
      }
    });

    $(".custom_fields input.field__input").on("keyup", function() {
      var value = $(this).val();
      $(this).next().val(value);
    });


    $(".custom_fields select.select__select").on("change", function() {
      var value = $(this).find("option:selected").val();
      $(this).next().val(value);
    });
  }

   // Global
   // Changement de langue
   $("#FooterLanguageForm span").click(function(e) {
      $(this).siblings('input[name=locale_code]').val($(this).data("value"));
      $(this).parent().submit();
   });

   // PAGES PRODUIT
  // Ouverture disponibilité
  $(document).on('click', '#drawer_disponibilite.drawer .drawer_close, #drawer_disponibilite', function () {
    $(".shop_availability").removeClass("open");
    $("body").removeClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").removeClass("active");
  });

  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.drawer").addClass("active");
  });

    $(".variant_button_label").on("click", function() {
      $(".variant_button_label").removeClass("active");
      $(this).addClass("active");
    });

   // Autres couleurs produits
   var selected_color = $(".color_variant.selected span").data("color");
   $(".color_variant").hover(function(e) {
      var hovered_color = $(this).find("span").data("color");
      $(".color_name").html(hovered_color);
   }, function(e) {
      $(".color_name").html(selected_color);
   });

   // Tabs
   $(".product_details h2, .product_details .h2").click(function(e) {
      $(".product_details h2, .product_details .h2").not($(this)).removeClass("open");
      $(this).toggleClass("open");
      var tabs = $(".product_details h2, .product_details .h2");
      var content = $(".product_details > div");
      if (content.length) {
         $(tabs).not($(this)).next(content).slideUp();
          $(this).next("div").slideToggle();
      }
    });
   if ($(window).width() >= 990) {
      $(".product_details h2").click(function(e) {
         var selected_tab = $(this).data("title");
         $(this).siblings("h2").removeClass("selected");
         $(this).addClass("selected");
         $(this).parents(".product_details").find(".tab").hide();
         $(this).parents(".product_details").find("div[data-target='"+selected_tab+"']").show();
      });
   } else {
      $(".product_details.mobile .details_title > h2").click(function(e) {
         $(this).siblings("h2").removeClass("selected");
         $(this).addClass("selected");
         $(this).siblings("h2").not($(this)).next("div").slideUp(400);
         $(this).next("div").stop().slideToggle(400);
      });
   }

    $(document).on('click', '#drawer_sizing.drawer .drawer_close, #drawer_sizing.drawer', function () {
      $("body").removeClass("overflow-hidden");
      $("#drawer_sizing.drawer").removeClass("active");
    });

    $(document).on('click', '.sizing_guide', function () {
      $("body").addClass("overflow-hidden");
      $("#drawer_sizing.drawer").addClass("active");
    });

    if ($('#sizing_content').length) {
      $("#sizing_content .tabs p").click(function () {
        var $name = $(this).data("title");
        $("#sizing_content .tabs p").removeClass("selected");
        $(this).addClass("selected");
        $('#sizing_content .tab_content').hide();
        $('#sizing_content .tab_content[data-target="' + $name + '"]').show();
      });
    }

    if ($('.size_switch').length) {
    $(".size_switch").click(function () {
      $(this).find(".switch").toggleClass("on");
      $("table.cm, table.in").toggleClass("opened");
    });
  }

    $(document).on('click', '.pop_content, .drawer_wrapper_inner', function (event) {
      event.stopPropagation();
    });

   // PAGES COLLECTIONS
   // Sticky quicklinks dynamic offset top
   $(window).on("scroll", function () {
      var header_height = $(".shopify-section-header-sticky").height();
      if ($(".shopify-section-header-hidden").length > 0) {
        $(".facets-quicklinks").css("top", "0px");
      } else {
        $(".facets-quicklinks").css("top", header_height + "px");
      }

      if ($(window).width() <= 990) {
        if ($(".shopify-section-header-sticky").length > 0) {
          $(".facets-container").addClass("hide");
        } else {
          $(".facets-container").removeClass("hide");
        }
      }
    });

    // Debug ouverture search
    // MutationObserver pour surveiller l'ouverture/fermeture de la recherche dans le header
    if ($('.header__search details').length) {
      const $details = $('.header__search details');
      const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            if ($details.attr('open') !== undefined) {
              $('.facets-quicklinks').css('z-index', '0');
            } else {
              $('.facets-quicklinks').css('z-index', '2');
            }
          }
        });
      });
      observer.observe($details[0], { attributes: true });
    }


   // Back to top
    $(".back_to_top").click(function(e) {
      $("html, body").animate({scrollTop: 0}, 800, "easeOutQuart");
    });

   // PAGES SHOP THE LOOK
   if($(".shop-the-look-section").length) {
      var sticky_offset = $(".shop-the-look-section:first-of-type").offset().top;
      $(".sticky_stl").css("top", sticky_offset + "px");

      $(".sticky_stl a").click(function(){
         var $to = $(this).attr("href");
         $("html, body").animate({scrollTop: $($to).offset().top - sticky_offset }, 800, "easeOutQuart");
      });
   }

   // Debug Zoom photo produit
   $(".shop-the-look-section .product__media-wrapper").click(function(){
      $("product-modal").removeAttr("open");
      $(this).parents(".featured-product").next("product-modal").attr("open", "");
      $(this).parents(".featured-product").next("product-modal").find(".product-media-modal__content img:first-of-type").addClass("active");
   });

   // SECTIONS DYNAMIQUES
   // Liste de collections (focus icone)
   $(".elx-collections-list a").mousemove(function(event){
      var left = event.pageX - $(this).offset().left;
      var top = event.pageY - $(this).offset().top;
      $(this).find(".cursor").css("left", left + "px");
      $(this).find(".cursor").css("top", top + "px");
   });

   //Sliders
   // Initialisation du slider
   $('.section_slider').on('init', function(e) {
      $(this).find('.slick-arrow').find("span").remove();
      var cat_next = $(this).find(".slick-active").next(".slick-slide").data("name");
      var cat_prev = $(this).find(".slick-active").prev(".slick-slide").data("name");
      $(this).find('.slick-next').append("<span>" + cat_next + "</span>");
      $(this).find('.slick-prev').append("<span>" + cat_prev + "</span>");
   });

   // Activation du slider
   $('.section_slider').slick({
      arrows: true,
      dots: false,
      infinite: true,
      focusOnHover: true
   });

   $('.slider_stl').slick({
      arrows: true,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
              slidesToShow: 1
          }
        }
      ]
   });

   $('.elx-banner-slider').slick({
      arrows: false,
      dots: true,
      infinite: true,
      focusOnHover: false,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
   });

    $('.elx-products-list').slick({
      arrows: true,
      dots: false,
      autoplay: false,
      centerMode: false,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 749,
          settings: {
            arrows: false,
            dots: false,
            centerMode: true,
            slidesToShow: 1,
          }
        }
      ]
    });

   // Gestion des flèches et de leur légende
   $(".section_slider .slick-next, .section_slider .slick-prev").click(function(e) {
      var $this = $(this).parent(".section_slider");
      $this.find(".slick-arrow span").remove();
      var cat_next = $this.find(".slick-active").next(".slick-slide").data("name");
      var cat_prev = $this.find(".slick-active").prev(".slick-slide").data("name");
      $this.find('.slick-prev').append("<span>" + cat_prev + "</span>");
      $this.find('.slick-next').append("<span>" + cat_next + "</span>");
   });

   // PAGES RSE
   // Slider
   $('.slider-rse').slick({
      arrows: false,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      focusOnSelect: false,
      responsive: [{
            breakpoint: 1280,
            settings: {
               slidesToShow: 3,
            }
         },
         {
            breakpoint: 1024,
            settings: {
               slidesToShow: 2,
            }
         },
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 1,
            }
         }
      ]
   });

   // Lien sur section banner entière
   $(".elx-banner-slider .image_desktop , .elx-banner").click(function(e) {
      var redirect = $(this).data("target");
      window.location.href = redirect;
   });

   $(".partners h2 span").click(function(e) {
      $('.slider-rse').slick('slickNext');
   });

   // Section vidéo
   $('.background').on('click', function(ev) {
      $(this).siblings("iframe")[0].src += "&autoplay=1";
      $(this).remove();
      ev.preventDefault();
   });


   $('.pwd_visibility').click(function() {
      const eyeIcon = $(this);
      const pwdInput = $('#CustomerPassword');

      pwdInput.off('blur');

      if (eyeIcon.hasClass('hidden_pwd')) {
         eyeIcon.removeClass('hidden_pwd').addClass('visible_pwd');
         pwdInput.attr('type', 'text').focus();

         pwdInput.one('blur', function(e) {
            if ($(e.relatedTarget).attr('id') !== 'togglePassword') {
            pwdInput.attr('type', 'password');
            eyeIcon.removeClass("visible_pwd").addClass('hidden_pwd');
            }
         });

      } else {
         eyeIcon.removeClass('visible_pwd').addClass('hidden_pwd');
         pwdInput.attr('type', 'password');
      }
   });
});
